module.exports = __webpack_public_path__ + "static/img/RWDA1265-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWDA1265-G_1.png
// module id = gMox
// module chunks = 0